import { update, map, findIndex, propEq, pick, isEmpty, append, reject, find, pathOr } from 'ramda';
import Vue from 'vue';
import { tseParseJobs, tseToSurvey } from '../../utils/tse.utils';

const THREE_SIXTY_CODE = 'E360';

export default {
	resetState({ commit }) {
		commit('RESET_TSE_STATE');
	},
	async getJobsAreas({ commit }) {
		const { data = [] } = await Vue.prototype.$httpPraktiko.get('groups');
		const parsedGroups = map(pick(['id', 'code', 'name']), data);
		commit('UPDATE_JOBS_AREAS', parsedGroups);
	},
	async getFilteredJobs({ commit }, selectedIds) {
		if (isEmpty(selectedIds)) {
			commit('UPDATE_JOBS', []);
			return;
		}
		const params = selectedIds.join(',');
		const { data = [] } = await Vue.prototype.$httpPraktiko.get(`groups/jobs?areaIds=${params}`);
		commit('UPDATE_JOBS', tseParseJobs(data));
	},
	async getToolConfiguration({ commit, state }) {
		const { data = [] } = await Vue.prototype.$http.get(`tools/${THREE_SIXTY_CODE}`);
		const stepsConfiguration = pathOr({}, ['config', 'newEvaluation'], data);
		commit('UPDATE_FLOW_CONFIGURATION', {
			...state.moduleConfiguration,
			...stepsConfiguration,
		});
	},
	async createSurvey({ state }, { surveyName, answerId }) {
		const selectedJobs = pathOr([], ['evaluationFlow', 'selectedJobs'], state);
		const surveyPayload = tseToSurvey(selectedJobs, surveyName, answerId);
		await Vue.prototype.$http.post('polls', surveyPayload);
	},
	updateSelectedJob({ commit, state }, job) {
		const { selectedJobs } = state.evaluationFlow;
		const index = findIndex(propEq('id', job.id), selectedJobs);
		const updatedList = update(index, job, selectedJobs);
		commit('UPDATE_SELECTED_JOBS', updatedList);
	},
	updateSelectedAreasIds({ commit }, ids) {
		commit('UPDATE_SELECTED_AREAS_IDS', ids);
	},
	toggleJobSelection({ commit, state }, job) {
		const { selectedJobs } = state.evaluationFlow;
		const selectedJob = find(propEq('id', job.id), selectedJobs);
		let updateJobs = [];
		if (selectedJob) {
			updateJobs = reject(propEq('id', job.id), selectedJobs);
		} else {
			updateJobs = append(job, selectedJobs);
		}
		commit('UPDATE_SELECTED_JOBS', updateJobs);
	},
	nextStep({ commit, state }) {
		commit('UPDATE_CURRENT_STEP', state.evaluationFlow.currentStep + 1);
	},
	prevStep({ commit, state }) {
		commit('UPDATE_CURRENT_STEP', state.evaluationFlow.currentStep - 1);
	},
};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/store/evaluation/actions.js